module.exports = __webpack_public_path__ + "img/paused-name-icon.805dd34a.svg";